import { Button, Tooltip } from 'components/ui';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { InspectionSubjectLink } from 'utils/link';
import { AddIcon, WarningIcon } from 'components/uiIcons';
import { ButtonSpan } from 'components/styles_components/span';
import Create from 'components/inspection_subject/modal/create';
import theme from 'theme';

const CreateButton = ({
  overInspectionSubjectsLimit,
  placeId,
  adminRole = true,
  size = 'medium',
  label = <FormattedMessage id="button.add" />,
}) => {
  const { addModal, removeModal } = useModal();
  const setInfo = useInfo();
  const intl = useIntl();
  const navigate = useNavigate();

  const button = (
    <Button
      disabled={overInspectionSubjectsLimit || !adminRole}
      size={size}
      startIcon={
        overInspectionSubjectsLimit || !adminRole ? (
          <WarningIcon sx={{ color: theme.palette.error.main }} />
        ) : null
      }
      endIcon={<AddIcon />}
      onClick={() =>
        addModal(
          <Create
            handleClose={() => removeModal()}
            placeId={placeId}
            onSuccess={(inspectionSubject) => {
              removeModal();
              setInfo('info.inspection_subject.created');
              navigate(InspectionSubjectLink(inspectionSubject.id));
            }}
          />
        )
      }
      variant="contained"
    >
      <ButtonSpan>{label}</ButtonSpan>
    </Button>
  );

  if (!adminRole) {
    return (
      <Tooltip title={intl.formatMessage({ id: 'user.place.no_admin' })}>
        <span>{button}</span>
      </Tooltip>
    );
  }

  if (overInspectionSubjectsLimit) {
    return (
      <Tooltip title={intl.formatMessage({ id: 'user.plan.over_inspection_subject_limit' })}>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};

export default CreateButton;
